// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const REMOVE_TEAM_MEMBER = "mondoo.captain.Captain.RemoveTeamMember";
